import React from "react";
import { useMediaQuery } from "@chakra-ui/react";
import NavbarMobile from "./mobileNav";
import NavbarDesktop from "./navBarDesktop";

export default function Navbar() {
  const [isLargerThanSmallestDevice] = useMediaQuery("(min-width: 480px)");

  if (isLargerThanSmallestDevice) {
    return <NavbarDesktop />;
  } else {
    return <NavbarMobile />;
  }
}
